<template>
  <div class="display-order-card-wrapper">
    <div class="header-wrapper">
      <h3 class="title">{{ value.ticket_name }}</h3>
      <span class="vice">No.{{ value.ordersn }}</span>
    </div>
    <div class="neck">
      <span class="border" />
    </div>
    <div class="content-wrapper">
      <display-order-card-cell title="种类" :content="value.shape" />
      <display-order-card-cell title="出票时间" :content="value.createtime" />
      <display-order-card-cell
        v-if="status === 'consumed'"
        title="核销时间"
        :content="value.checktime"
      />
      <display-order-card-cell title="可用日期" :content="value.use_date" />
      <display-order-card-cell title="场次" :content="value.ticket_type" />
      <display-order-card-cell
        v-if="value.no"
        title="座位号"
        :content="`${value.category_name} ${value.no}`"
      />
      <display-order-card-cell
        v-if="!value.no"
        title="分类"
        :content="value.category_name"
      />
      <display-order-card-cell
        v-if="value.count"
        title="剩余可用次数"
        :content="`${value.count}次`"
      />
      <display-order-card-cell title="姓名" :content="value.name" />
      <display-order-card-cell title="支付方式" :content="value.paychannel" />
      <display-order-card-cell
        title="价格"
        :content="`￥${value.price || 0}`"
      />
      <display-order-card-cell
        v-if="value.status===2||value.status===-1"
        title="状态"
        :content="value.status===2?'处理中':value.status===-1?'已退款':''"
      />
      <van-image
        v-if="value.status !== 2"
        lazy-load
        :width="150"
        :height="150"
        :src="value.qr_img"
        class="qrcode"
        @click="handleQrcodePreview"
      />
      <div class="button-wrapper">
        <van-button
          v-if="status === 'available'"
          type="danger"
          class="refund-button"
          @click="handleRefundClick"
          >退票</van-button
        >
      </div>
    </div>
    <van-overlay :show="isPreviewShown" @click="togglePreview">
      <van-image :src="value.qr_img" width="60%" class="preview-image" />
    </van-overlay>
  </div>
</template>
<script>
import DisplayOrderCardCell from './DisplayOrderCardCell.vue';

export default {
  components: {
    DisplayOrderCardCell,
  },
  props: {
    value: [Object],
  },
  data() {
    return {
      isPreviewShown: false,
    };
  },
  computed: {
    status() {
      const { status } = this.value;
      if (status) {
        if (status === 1) return 'consumed';
        return 'refund';
      }
      return 'available';
    }
  },
  methods: {
    handleQrcodePreview() {
      this.isPreviewShown = true;
    },
    handleRefund() {
      this.$emit('refund', this.value.code);
    },
    togglePreview() {
      this.isPreviewShown = !this.isPreviewShown;
    },
    handleRefundClick() {
      this.$dialog
        .confirm({
          title: '退票',
          message: '确定退票？',
          beforeClose: (action, done) => {
            if (action === 'confirm') this.handleRefund();
            done();
          },
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.display-order-card-wrapper {
  padding: 16px 0;
  overflow: hidden;
  margin: 8px 12px 8px;
  background-color: #fff;
  box-shadow: 0 6px 24px rgba(17, 26, 52, 0.05);
  .header-wrapper {
    display: flex;
    padding: 2px 0;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 20px;
      color: #41485d;
      padding-left: 16px;
    }
    .vice {
      font-size: 12px;
      color: #c5cad5;
      padding-right: 16px;
    }
  }
  .neck {
    height: 16px;
    margin: 0 16px;
    position: relative;
    box-sizing: border-box;
    &::before,
    &::after {
      top: 0;
      content: '';
      width: 16px;
      height: 16px;
      position: absolute;
      border-radius: 16px;
      background-color: #f3f4f5;
    }
    &::before {
      left: -24px;
    }
    &::after {
      right: -24px;
    }
    .border {
      left: 0;
      right: 0;
      top: 50%;
      height: 1px;
      display: block;
      position: absolute;
      border-top: 1px dashed #c5cad5;
    }
  }
  .qrcode {
    display: block;
    margin: 16px auto;
  }
  .button-wrapper {
    padding: 0 16px;
    // text-align: right;
    .refund-button {
      width: 100%;
      height: 32px;
      line-height: 32px;
    }
  }
  .preview-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    overflow: hidden;
  }
}
</style>
